var __jsx = React.createElement;
import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'next-i18next';
import FAQShared from '@spa/shared/components/FAQ';
import Separator from '@spa/shared/components/Unisystem/Separator';
import { trackOfferPageFaqOpened } from '@spa/offer/store/actions/tracking';
import { transformQuestionsAnswersAndRelatedLinks } from '@spa/shared/utils/transformers/seo';
var FAQ = function FAQ(_ref) {
  var location = _ref.location,
    trackOfferPageFaqOpenedAction = _ref.trackOfferPageFaqOpenedAction;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var _transformQuestionsAn = transformQuestionsAnswersAndRelatedLinks(location, language),
    _transformQuestionsAn2 = _transformQuestionsAn.questionsAnswers,
    questionsAnswers = _transformQuestionsAn2 === void 0 ? null : _transformQuestionsAn2;
  if (!(questionsAnswers !== null && questionsAnswers !== void 0 && questionsAnswers.length)) {
    return null;
  }
  return __jsx(React.Fragment, null, __jsx(FAQShared, {
    title: t('Frequently asked questions'),
    questionsAnswers: questionsAnswers,
    learnMoreText: t('Learn more'),
    trackOpen: trackOfferPageFaqOpenedAction
  }), __jsx(Separator, null));
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var location = _ref2.location;
  return {
    location: location
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    trackOfferPageFaqOpenedAction: function trackOfferPageFaqOpenedAction(question) {
      return dispatch(trackOfferPageFaqOpened({
        question: question
      }));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(FAQ);